<template>
    <b-container>
        <b-row>
            <b-col>
                <app-title
                    text="Creación de evaluaciones de desempeño"
                ></app-title>
            </b-col>
        </b-row>
        <b-row class="justify-content-start mt-3">
            <b-col cols="3">
                <b-btn
                    variant="primary"
                    block
                    @click="openPerformanceEvaluationForm"
                >
                    <i class="fa fa-plus"></i> Crear nueva evaluación
                </b-btn>
            </b-col>
        </b-row>
        <b-card>
            <b-row>
                <app-performance-evaluation-filters
                    @filters="onFilter"
                    @clear="onClear"
                />
            </b-row>
        </b-card>
        <b-row class="mt-3">
            <b-col>
                <app-performance-evaluation-list
                    ref="performanceEvaluationList"
                    :table-data="tableData"
                    :on-change-page="onChangePage"
                    @edit="onEdit"
                    @delete="onDelete"
                    @sort="onSort"
                    @user-assign="openUserAssignForm"
                    @people-evaluated="openPopupPeopleEvaluated"
                ></app-performance-evaluation-list>
            </b-col>
        </b-row>
        <!-- popup -->
        <app-pop-up
            id="performance-evaluation-form-window"
            title="Creación de nueva evaluación de desempeño"
        >
            <template slot="body">
                <app-performance-evaluation-form
                    ref="performanceEvaluationForm"
                    @saved="onSaved"
                ></app-performance-evaluation-form>
            </template>
            <template slot="buttons">
                <div>
                    <b-btn
                        id="btnSave"
                        variant="primary"
                        @click="onSavePerformanceEvaluation"
                        :disabled="inProgress"
                    >
                        <i class="fa fa-save"></i> Guardar
                    </b-btn>
                </div>
            </template>
        </app-pop-up>
        <!-- popup de asignacion de usuarios -->
        <app-pop-up
            id="user-assignment-form-window"
            title="Asignación de usuarios"
            size="large"
        >
            <template slot="body">
                <app-user-assignment-form
                    ref="userAssignmentForm"
                    @saved="onSavedUserAssignment"
                    :evaluation-id="evaluationId"
                ></app-user-assignment-form>
            </template>
            <template slot="buttons">
                <div>
                    <b-btn
                        id="btnSaveUserAssignment"
                        variant="primary"
                        @click="onSaveUserAssignment"
                        :disabled="inProgress"
                    >
                        <i class="fa fa-save"></i> Guardar
                    </b-btn>
                </div>
            </template>
        </app-pop-up>
        <!-- popup de personas evaluadas y descarga de reporte -->
        <app-pop-up
            id="people-evaluated-window"
            title="Personas Calificadas"
            size="large"
        >
            <template slot="body">
                <app-people-evaluated-form
                    ref="peopleEvaluatedForm"
                ></app-people-evaluated-form>
            </template>
        </app-pop-up>
    </b-container>
</template>
<script>
import PerformanceEvaluationList from './PerformanceEvaluationList'
import PerformanceEvaluationForm from './PerformanceEvaluationForm'
import PerformanceEvaluationFilters from './PerformanceEvaluationFilters'
import appPeopleEvaluatedForm from './PeopleEvaluatedForm'
import UserAssignmentForm from './UserAssignmentForm'
export default {
    components: {
        appPerformanceEvaluationList: PerformanceEvaluationList,
        appPerformanceEvaluationForm: PerformanceEvaluationForm,
        appPerformanceEvaluationFilters: PerformanceEvaluationFilters,
        appUserAssignmentForm: UserAssignmentForm,
        appPeopleEvaluatedForm
    },
    data: () => ({
        page: 1,
        tableData: [],
        sortDir: 'desc',
        sortBy: 'created_at',
        filters: '',
        evaluationId: 0,
    }),
    methods: {
        openPopupPeopleEvaluated(item){
            this.$refs.peopleEvaluatedForm.loadPeopleEvaluated(item.id)
            this.$bus.$emit('people-evaluated-window.open')

        },
        onSavedUserAssignment(data) {
            toastr.success(data.msg)
            this.$bus.$emit('user-assignment-form-window.close')
        },
        onSaveUserAssignment() {
            this.$refs.userAssignmentForm.save()
        },
        openUserAssignForm(item) {
            this.evaluationId = item.id
            this.$refs.userAssignmentForm.reset()
            this.$bus.$emit('user-assignment-form-window.open')
        },
        onFilter(filters) {
            this.filters = filters
            this.page = 1
            this.loadPerformanceEvaluations()
        },
        openPerformanceEvaluationForm() {
            this.$refs.performanceEvaluationForm.reset()
            this.$bus.$emit('performance-evaluation-form-window.open')
        },
        async loadPerformanceEvaluations() {
            try {
                const params = {
                    ...this.filters,
                    page: this.page,
                    sortBy: this.sortBy,
                    sortDir: this.sortDir,
                    administrative: true
                }
                const { data } = await repo.get(
                    'performance-evaluations',
                    params
                )
                this.tableData = data
            } catch (err) {
                this.handleErrors(err)
            }
        },
        onChangePage(page) {
            this.page = page
            this.loadPerformanceEvaluations()
        },
        onSort(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDir = ctx.sortDir
            this.loadPerformanceEvaluations()
        },
        onEdit(evaluation) {
            this.$refs.performanceEvaluationForm.fill(evaluation)
            this.$bus.$emit('performance-evaluation-form-window.open')
        },
        onDelete(evaluation) {
            this.$bvModal
                .msgBoxConfirm(
                    '¿Esta seguro de eliminar la evaluación de desempeño?',
                    {
                        title: 'Confirmación',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Eliminar',
                        cancelTitle: 'Cancelar',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true,
                    }
                )
                .then(value => {
                    value && this.deletePerformanceEvaluation(evaluation.id)
                })
                .catch(err => {
                    console.log(err)
                })
        },
        onSavePerformanceEvaluation() {
            const flagAdministrative = true
            this.$refs.performanceEvaluationForm.savePerformanceEvaluation(flagAdministrative)
        },
        async deletePerformanceEvaluation(id) {
            const { data } = await repo.delete(`performance-evaluations/${id}`)
            if (data.status) {
                toastr.success(data.msg)
                this.loadPerformanceEvaluations()
            } else {
                toastr.error('Ocurrio un error al eliminar la evaluación')
            }
        },
        onSaved(data) {
            toastr.success(data.msg)
            this.$bus.$emit('performance-evaluation-form-window.close')
            this.loadPerformanceEvaluations()
        },
        onClear() {
            this.loadPerformanceEvaluations()
        },
    },
    mounted() {
        this.loadPerformanceEvaluations()
    },
}
</script>
